const ACCESS_TOKEN_KEY = 'ACCESS_TOKEN_KEY';
const REFRESH_TOKEN_KEY = 'REFRESH_TOKEN_KEY';
const SERVICE_ID_KEY = 'SERVICE_ID_KEY';
const SESSION_CACHE_KEY = 'SESSION_CACHE_KEY';

export const setTokens = (accessToken: string, refreshToken: string): void => {
  window.localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
  window.localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
};

export const setAccessToken = (accessToken: string): void => {
  window.localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
};

export const clearAccessTokens = (): void => {
  window.localStorage.setItem(ACCESS_TOKEN_KEY, '');
};

export const clearTokens = (): void => {
  window.localStorage.setItem(ACCESS_TOKEN_KEY, '');
  window.localStorage.setItem(REFRESH_TOKEN_KEY, '');
  window.localStorage.removeItem(SERVICE_ID_KEY);
};

export const getAccessToken = (): string => {
  return window.localStorage.getItem(ACCESS_TOKEN_KEY) || '';
};
export const getRefreshToken = (): string => {
  return window.localStorage.getItem(REFRESH_TOKEN_KEY) || '';
};

export const setServiceId = (serviceId: string): void => {
  window.localStorage.setItem(SERVICE_ID_KEY, serviceId);
};

export const getServiceId = (): string => {
  return window.localStorage.getItem(SERVICE_ID_KEY) || '';
};

export const clearServiceId = (): void => {
  window.localStorage.setItem(SERVICE_ID_KEY, '');
};

export const setCachedSession = <T>(session: T): void => {
  try {
    window.localStorage.setItem(SESSION_CACHE_KEY, JSON.stringify(session));
  } catch (error) {
    console.error('Failed to cache session:', error);
  }
};

export const getCachedSession = <T>(): T | null => {
  try {
    const cached = window.localStorage.getItem(SESSION_CACHE_KEY);
    return cached ? JSON.parse(cached) : null;
  } catch (error) {
    console.error('Failed to read cached session:', error);
    return null;
  }
};

export const clearCachedSession = (): void => {
  window.localStorage.removeItem(SESSION_CACHE_KEY);
};

/**
 * Whether the stored access token is past (or within `leewaySeconds` of) its
 * `exp` claim. An unreadable token counts as expired.
 */
export const isAccessTokenExpired = (leewaySeconds = 5): boolean => {
  const [, payload] = getAccessToken().split('.');
  if (!payload) return true;

  try {
    const { exp } = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
    return typeof exp !== 'number' || exp * 1000 - leewaySeconds * 1000 <= Date.now();
  } catch {
    return true;
  }
};
